export const TEST_NAME = '2020_Q1_B&S_ESTIMATE_CONTENT';
export const HEAP_EXPERIMENT_NAME = 'Experiment: B&S Estimate Content 2020 Q1';
